import * as Sentry from "@sentry/react";

export const useSentry = import.meta.env.VITE_SENTRY_ACTIVATED !== "false";
if (!useSentry) {
  console.info("Env var deactivated Sentry");
}

if (useSentry) {
  Sentry.init({
    dsn: "https://d989213283978d49a58f901f6360df56@o4509270159065088.ingest.de.sentry.io/4509786308804688",
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: false,
    integrations: [
      Sentry.replayIntegration({ maskAllText: false }),
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/booking\.aheadhealth\.com/,
      /^https:\/\/rnaixxwwvyedkujwijlp\.supabase\.co/,
    ],
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
  });
}
